import { AngularServices, getAngularService, UserRole } from '../../core';
export const getUserRole = () => {
    const rootScope = getAngularService(AngularServices.RootScope);
    return rootScope.currentState === UserRole.Patient
        ? UserRole.Patient
        : UserRole.Doctor;
};
export const isPatient = () => getUserRole() === UserRole.Patient;
export const isDoctor = () => getUserRole() === UserRole.Doctor;
